import { useState, useEffect } from 'react'
import { profileUrl } from '../api/tmdb'
import { IconClapper } from './icons'

const PLACEHOLDER = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='185' height='278' viewBox='0 0 185 278'%3E%3Crect fill='%23333' width='185' height='278'/%3E%3Ccircle fill='%23555' cx='92' cy='100' r='40'/%3E%3Cellipse fill='%23555' cx='92' cy='220' rx='60' ry='50'/%3E%3C/svg%3E"

/**
 * Phase C – 3-second countdown before H2H gameplay begins.
 * Props:
 *   startActor – { id, name, profile_path }
 *   goalActor  – { id, name, profile_path }
 *   onStart    – called when countdown reaches 0
 */
export default function H2HGetReady({ startActor, goalActor, onStart }) {
  const [count, setCount] = useState(3)

  useEffect(() => {
    if (count === 0) {
      onStart()
      return
    }
    const id = setTimeout(() => setCount(c => c - 1), 1000)
    return () => clearTimeout(id)
  }, [count]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="h2h-get-ready">
      <p className="h2h-get-ready__label">Get Ready!</p>

      <div className="h2h-get-ready__matchup">
        <div className="h2h-get-ready__actor">
          <img
            src={profileUrl(startActor?.profile_path) || PLACEHOLDER}
            alt={startActor?.name}
            onError={(e) => { e.target.src = PLACEHOLDER }}
          />
          <span className="h2h-get-ready__actor-name">{startActor?.name}</span>
          <span className="h2h-get-ready__role">START</span>
        </div>

        <span className="h2h-get-ready__arrow">→</span>

        <div className="h2h-get-ready__actor">
          <img
            src={profileUrl(goalActor?.profile_path) || PLACEHOLDER}
            alt={goalActor?.name}
            onError={(e) => { e.target.src = PLACEHOLDER }}
          />
          <span className="h2h-get-ready__actor-name">{goalActor?.name}</span>
          <span className="h2h-get-ready__role">GOAL</span>
        </div>
      </div>

      <div className="h2h-get-ready__countdown" key={count}>
        {count > 0 ? count : <IconClapper size={40} />}
      </div>
    </div>
  )
}
